import * as React from 'react';
import styled from 'styled-components';
import { t } from '@deltasierra/shared';
import { DSTypography } from '../../mui/Typography';

const WarningContainer = styled.div`
    background-color: #ffebee;
    border: 2px solid #f44336;
    border-radius: 4px;
    padding: 16px;
    max-width: 400px;
`;

export function LightboxDangerWarning(): JSX.Element {
    return (
        <WarningContainer data-testid="lightbox-dangerous-warning">
            <DSTypography color="error" variant="h6">
                {t('ASSET_LIBRARY.SECURITY_WARNING')}
            </DSTypography>
            <DSTypography>
                {t('ASSET_LIBRARY.SECURITY_WARNING_DESCRIPTION')}
            </DSTypography>
        </WarningContainer>
    );
}
LightboxDangerWarning.displayName = 'LightboxDangerWarning';
